var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTask48Filled = function SvgIconTask48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.37 11.3h-1.7v-.1a2.9 2.9 0 0 0-2.9-2.9h-9.6a2.9 2.9 0 0 0-2.9 2.9v.1H14.6a5.3 5.3 0 0 0-5.3 5.3v17.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.3 5.3 0 0 0-5.33-5.3ZM19.67 13v-1.3h8.6v2.6h-8.6V13Zm4.58 17a2.88 2.88 0 0 1-2 .83h-.06a2.859 2.859 0 0 1-2.06-.92l-3.36-3.59L19.25 24l3 3.22 6.55-6.47 2.39 2.42L24.25 30Z",
    fill: "current"
  })));
};
export default SvgIconTask48Filled;